import template from 'lodash/string/template';
import get_bundle from '../domain/get_bundle';

export default function format_timeago(locale, delta) {
  var seconds = delta / 1000;
  var minutes = seconds / 60;
  var hours = minutes / 60;
  var days = hours / 24;
  var bundle = get_bundle(locale).timeago;
  
  return days > 3 ?
    template(bundle.days3)({}) :
    days > 1 ?
    template(bundle.days)({
      dd: locale.format_integer(days)
    }) :
    hours > 1 ?
    template(bundle.hours)({
      hh: locale.format_integer(hours)
    }) :
    minutes > 1 ?
    template(bundle.minutes)({
      mm: locale.format_integer(minutes)
    }) :
    bundle.seconds;
}





/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/util/formatTimeAgo.js
 **/